<template>
  <div>
    <DeleteModal modal-id="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      id="modal-edit"
      :no-close-on-backdrop="true"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('hospital.Add-ServiceType') || 'Add Service Type'
          : $t('hospital.Edit-ServiceType') || 'Edit Service Type'
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="12" cols="12">
            <b-form-group :label="$t('common.name') || 'Name'" label-for="name">
              <b-form-input
                id="name"
                v-model="EditForm.name"
                :placeholder="$t('common.name') || 'Name'"
              />
              <p class="text-danger mt-1">
                {{ errorForm.name }}
              </p>
            </b-form-group>
          </b-col>
          <b-col md="12" cols="12">
            <b-form-group
              :label="$t('common.description') || 'Description'"
              label-for="description"
            >
              <b-form-textarea
                id="description"
                v-model="EditForm.description"
                :placeholder="$t('common.description') || 'Description'"
                rows="3"
              />
              <p class="text-danger mt-1">
                {{ errorForm.description }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          ref="button"
          variant="primary"
          class="m-0"
          :disabled="loading"
          block
          @click="submitItem"
        >
          <span v-if="!loading">{{
            createMode ? $t("common.add") : $t("common.update")
          }}</span>
          <b-spinner v-else small />
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('hospital.ServiceTypes') || 'Service Types'">
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>
              {{ $t("hospital.Filter-ServiceTypes") || "Filter Service Types" }}
            </h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.name') || 'Name'" label-for="Name">
              <b-form-input
                id="Name"
                v-model="searchName"
                :placeholder="$t('common.name') || 'Name'"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getServiceTypesList()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1" />
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("hospital.ServiceTypes") || "Service Types" }}</h2>
          <b-button
            v-if="$store.state.app.permissions.includes('store-serviceType')"
            variant="primary"
            @click="show(EditForm, 'create')"
          >
            {{ $t("common.add") }}
          </b-button>
        </div>

        <b-table
          v-if="!loading"
          :items="this.data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
        >
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                delete-perm="delete-serviceType"
                edit-perm="update-serviceType"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >Showing {{ (page - 1) * take + 1 }} to
                {{ Math.min(page * take, dataCount) }} of
                {{ dataCount }} Service Types</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @change="getServiceTypesList()"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BFormTextarea,
  BTable,
  BPagination,
  BSpinner,
  BIconSearch,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";

export default {
  components: {
    DeleteModal,
    BCard,
    ActionsButtons,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BFormTextarea,
    BTable,
    BPagination,
    BSpinner,
    BIconSearch,
  },
  mixins: [permissionChecker],
  data() {
    return {
      take: 10,
      loading: true,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        description: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        description: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        {
          key: "name",
          sortable: true,
          label: this.$t("common.name") || "Name",
        },
        {
          key: "description",
          sortable: false,
          label: this.$t("common.description") || "Description",
        },
        { key: "actions", label: this.$t("common.actions") || "Actions" },
      ],
      searchName: "",
      page: 1,
      deleteForm: null,
    };
  },
  mounted() {
    this.getServiceTypesList();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          description: "",
          _method: "POST",
        };
        this.errorForm = {
          name: "",
          description: "",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.name = item.name || "";
        this.EditForm.description = item.description || "";
        this.EditForm._method = "PUT";
        this.errorForm = {
          name: "",
          description: "",
        };
      }
      this.$bvModal.show("modal-edit");
    },
    async getServiceTypesList() {
      this.loading = true;

      let url = `/serviceTypes?page=${this.page}&take=${this.take}&sort=-id`;

      if (this.searchName) {
        url += `&filter[name]=${this.searchName}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total || 0;
      this.data = this.all_data.data || [];
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/serviceTypes/${this.deleteForm.id}`)
        .then((response) => {
          this.getServiceTypesList();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "CheckIcon",
              variant: "success",
              text: `Service Type ${this.deleteForm.name} deleted successfully`,
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text:
                error.response?.data?.message ||
                `Error deleting ${this.deleteForm.name}`,
            },
          });
        });
    },
    submitItem() {
      this.loading = true;
      let count = 0;
      this.errorForm.name = "";
      this.errorForm.description = "";

      // Clear empty fields
      for (const item in this.EditForm) {
        if (this.EditForm[item] === "" || this.EditForm[item] === null) {
          if (item !== "_method" && item !== "id") {
            delete this.EditForm[item];
          }
        }
      }

      // Validate required fields
      if (!this.EditForm.name || this.EditForm.name.trim() === "") {
        count++;
        this.errorForm.name = "The name field is required.";
      }

      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        this.params.form = this.EditForm;
        this.params.path = "/serviceTypes";
        this.$store
          .dispatch("create", this.params)
          .then((response) => {
            this.getServiceTypesList();
            this.loading = false;
            this.$bvModal.hide("modal-edit");
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Success",
                icon: "CheckIcon",
                variant: "success",
                text: "Service Type created successfully",
              },
            });
          })
          .catch((error) => {
            this.loading = false;
            if (error.response?.status === 400) {
              // Set field errors
              Object.keys(error.response.data).forEach((key) => {
                if (this.errorForm.hasOwnProperty(key)) {
                  this.errorForm[key] = error.response.data[key][0];
                }
              });
              // Show toast for validation errors
              Object.keys(error.response.data).forEach((key) => {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Validation Error",
                    variant: "danger",
                    text: error.response.data[key][0],
                  },
                });
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  variant: "danger",
                  text:
                    error.response?.data?.message ||
                    "Error creating service type",
                },
              });
            }
          });
      } else {
        this.params.form = this.EditForm;
        this.params.path = `/serviceTypes/${this.EditForm.id}`;
        this.$store
          .dispatch("update", this.params)
          .then((response) => {
            this.getServiceTypesList();
            this.loading = false;
            this.$bvModal.hide("modal-edit");
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Success",
                icon: "CheckIcon",
                variant: "success",
                text: "Service Type updated successfully",
              },
            });
          })
          .catch((error) => {
            this.loading = false;
            if (error.response?.status === 400) {
              // Set field errors
              Object.keys(error.response.data).forEach((key) => {
                if (this.errorForm.hasOwnProperty(key)) {
                  this.errorForm[key] = error.response.data[key][0];
                }
              });
              // Show toast for validation errors
              Object.keys(error.response.data).forEach((key) => {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "Validation Error",
                    variant: "danger",
                    text: error.response.data[key][0],
                  },
                });
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  variant: "danger",
                  text:
                    error.response?.data?.message ||
                    "Error updating service type",
                },
              });
            }
          });
      }
    },
  },
};
</script>

<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>
